import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row justify-between" }
const _hoisted_2 = { class: "row items-center" }
const _hoisted_3 = { class: "text-subtitle2 text-blue-grey-7" }
const _hoisted_4 = { class: "text-subtitle2 text-blue-grey-7" }
const _hoisted_5 = { class: "text-h4 text-info q-mb-sm" }
const _hoisted_6 = { class: "row text-h6" }
const _hoisted_7 = { class: "text-weight-regular text-blue-grey-7" }
const _hoisted_8 = { class: "text-weight-bold" }

import { date } from "quasar"
import SfxCard from "src/components/card/SfxCard.vue"
import { LABELS } from "src/env/labels"
import { DATE_TIME_FULL_MASK } from "src/util/constants/configurations"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { getTemporalInfo } from "src/util/functions/time"
import { IconRowElement } from "src/util/types/components/sfxIconRow"
import { SystemNotificationCardData } from "src/util/types/notifications"
import { computed, PropType } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxCardNotificationSystem',
  props: {
  data: {
    type: Object as PropType<SystemNotificationCardData>,
    required: true,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const timeSinceReceived = computed(() => {
  let date = props.data.timeSinceReceived
  if (typeof date !== "string") {
    date = date.toJSON()
  }
  return getTemporalInfo(date, "card")
})

const startTime = computed(() => date.formatDate(props.data.startTime, DATE_TIME_FULL_MASK))

const expectedDuration = computed(() =>
  date.getDateDiff(props.data.endTime, props.data.startTime, "minutes")
)

const iconRow: IconRowElement[] = [
  {
    name: Icons.NOTIFICATION_FROM_SUPPORT,
    color: "warning",
  },
]

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!

  return (_openBlock(), _createBlock(SfxCard, {
    class: "bg-orange-1 q-mb-sm sfx-card-notification",
    active: "",
    "icon-row": iconRow,
    clickable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_img, {
            class: "sfx-system-avatar q-mr-sm",
            src: "img/system_notification_avatar.svg",
            alt: _ctx.$t('sfxUserDisplay.profile_picture')
          }, null, 8, ["alt"]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("sfxCard.support", { support: _unref(LABELS).SUPPORT })), 1)
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(timeSinceReceived.value), 1)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("sfxCard.maintenance_scheduled")), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(expectedDuration.value + " " + _ctx.$t("notifications.time_period")) + "  ", 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("notifications.event_start") + " " + startTime.value), 1)
      ])
    ]),
    _: 1
  }))
}
}

})